module.exports = __webpack_public_path__ + "img/chofu_favorite_off.fd72cc2b.svg";